module.exports = __webpack_public_path__ + "static/media/buf_logo.8ff8aa41.svg";